(() => {
  const initPreorderNotice = () => {
    const notices = document.querySelectorAll(
      '[data-athletix-preorder-notice]'
    );

    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"]'
    );

    if (!notices.length) {
      checkoutButtons.forEach((button) => {
        button.disabled = false;
        button.removeAttribute('data-athletix-preorder-locked');
      });

      return;
    }

    const checkboxes = document.querySelectorAll(
      '[data-athletix-preorder-confirm]'
    );

    const updateCheckout = () => {
      const allConfirmed = [...checkboxes].every(
        (checkbox) => checkbox.checked
      );

      checkoutButtons.forEach((button) => {
        button.disabled = !allConfirmed;

        if (!allConfirmed) {
          button.setAttribute(
            'data-athletix-preorder-locked',
            'true'
          );
        } else {
          button.removeAttribute(
            'data-athletix-preorder-locked'
          );
        }
      });
    };

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', updateCheckout);
    });

    updateCheckout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initPreorderNotice
    );
  } else {
    initPreorderNotice();
  }

  document.addEventListener(
    'cart:updated',
    () => setTimeout(initPreorderNotice, 100)
  );

  document.addEventListener(
    'cart:refresh',
    () => setTimeout(initPreorderNotice, 100)
  );

  document.addEventListener(
    'athletix:cart-updated',
    () => setTimeout(initPreorderNotice, 100)
  );

  document.addEventListener(
    'shopify:section:load',
    () => setTimeout(initPreorderNotice, 100)
  );

  const observer = new MutationObserver(() => {
    initPreorderNotice();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();